var render = function render(){var _vm=this,_c=_vm._self._c;return _c('maintenance-page',{attrs:{"page-title":"Account","page-icon":"mdi-folder-outline","collection-name":"account","done-redirect-url":"/auth/admin/account?isHistory=true"}})
}
var staticRenderFns = []

export { render, staticRenderFns }